// src/app/guards/role.guard.ts
import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { ServicioSesion } from '@app/services/sesion/sesion.service';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  private _sesion = inject(ServicioSesion);
  private _router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    // 1. Obtener el rol esperado
    const rolEsperado = route.data['rol'] as string | string[];

    // 2. Verificar 
    if (this._sesion.verificarPermisoRol(rolEsperado)) {
      return true;
    }

    // 3. Si falla, mostrar feedback y redirigir
    Swal.fire({
        icon: 'warning',
        title: 'Acceso Restringido',
        text: `No estás autorizado para ver esta sección.`,
        timer: 3000
    });
    
    // Redirigir al dashboard o home por defecto
    return this._router.parseUrl('/dashboard');
  }
}